// ----------------------------------------------------------------------

// Accessing or writing web storage can throw (storage blocked by browser
// settings, private mode, quota exceeded). These helpers never throw.

type StorageArea = 'local' | 'session';

function getStorage(area: StorageArea): Storage {
  return area === 'local' ? window.localStorage : window.sessionStorage;
}

export function safeGetItem(area: StorageArea, key: string): string | null {
  try {
    return getStorage(area).getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(area: StorageArea, key: string, value: string): boolean {
  try {
    getStorage(area).setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(area: StorageArea, key: string): void {
  try {
    getStorage(area).removeItem(key);
  } catch {
    // ignore
  }
}
